import React from 'react';
import { Link } from 'react-router-dom';
import { FiDownload, FiMail, FiGithub, FiLinkedin, FiTwitter } from 'react-icons/fi';
import Typewriter from 'typewriter-effect';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import './HeroSection.css';

const HeroSection = ({ profile }) => {
  const [ref, isVisible] = useScrollAnimation();

  return (
    <section className="hero" ref={ref}>
      <div className="hero-bg">
        <div className="hero-gradient"></div>
        <div className="hero-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="particle" style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>
      </div>

      <div className={`hero-content ${isVisible ? 'fade-in' : ''}`}>
        <div className="hero-image-wrapper">
          <div className="hero-image-ring">
            <div className="hero-image">
              <img src={profile?.profilePhotoUrl || 'https://via.placeholder.com/300'} alt={profile?.fullName} />
            </div>
          </div>
          <div className="hero-status">
            <span className="status-dot"></span>
            Available for opportunities
          </div>
        </div>

        <div className="hero-text">
          <p className="hero-greeting">Hello, I'm</p>
          <h1 className="hero-name">{profile?.fullName || 'Deepak Chauhan'}</h1>
          <div className="hero-typewriter">
            <Typewriter
              options={{
                strings: [
                  profile?.designation || 'Software Developer',
                  '.NET Developer',
                  'Full Stack Developer',
                  'Problem Solver'
                ],
                autoStart: true,
                loop: true,
                deleteSpeed: 50,
                delay: 80,
              }}
            />
          </div>
          <p className="hero-bio">{profile?.shortBio}</p>

          <div className="hero-actions">
            <a href={profile?.resumeUrl || '#'} download className="btn btn-primary">
              <FiDownload /> Download Resume
            </a>
            <Link to="/contact" className="btn btn-outline">
              <FiMail /> Contact Me
            </Link>
          </div>

          <div className="hero-social">
            <a href={profile?.githubUrl || '#'} target="_blank" rel="noreferrer">
              <FiGithub />
            </a>
            <a href={profile?.linkedinUrl || '#'} target="_blank" rel="noreferrer">
              <FiLinkedin />
            </a>
            <a href={profile?.twitterUrl || '#'} target="_blank" rel="noreferrer">
              <FiTwitter />
            </a>
            <a href={`mailto:${profile?.email}`}>
              <FiMail />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
